var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.49968 1.45866H9.16667C9.27821 1.45866 9.37468 1.55512 9.37468 1.66667C9.37468 1.77822 9.27821 1.87467 9.16667 1.87468H7.49968C5.54961 1.87471 4.10378 2.21784 3.16081 3.16081C2.21784 4.10378 1.87471 5.54961 1.87468 7.49968V12.4997C1.87468 14.4499 2.21779 15.8965 3.16081 16.8395C4.10378 17.7824 5.54972 18.1246 7.49968 18.1247H12.4997C14.4499 18.1247 15.8965 17.7825 16.8395 16.8395C17.7825 15.8965 18.1247 14.4499 18.1247 12.4997V10.8337C18.1247 10.7221 18.2221 10.6247 18.3337 10.6247C18.4451 10.6249 18.5417 10.7222 18.5417 10.8337V12.4997C18.5417 14.7143 18.067 16.196 17.1315 17.1315C16.196 18.067 14.7143 18.5417 12.4997 18.5417H7.49968C5.28531 18.5416 3.8043 18.0669 2.86882 17.1315C1.9333 16.196 1.45866 14.7143 1.45866 12.4997V7.49968C1.45871 5.28519 1.93334 3.80429 2.86882 2.86882C3.80429 1.93334 5.28519 1.45871 7.49968 1.45866Z",
    fill: "#9C4FFF",
    stroke: "#9C4FFF",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.425 1.24824C16.112 1.24825 16.8476 1.58691 17.6301 2.36934C18.483 3.22227 18.8106 4.03162 18.7434 4.79219C18.6811 5.41428 18.3476 6.06303 17.6321 6.7707L17.6301 6.77168L11.0637 13.3391C10.7846 13.618 10.2427 13.8915 9.85178 13.9455H9.84983L7.34104 14.3039L7.32346 14.3068L7.30588 14.3107C7.251 14.3233 7.18929 14.3254 7.08323 14.3254C6.7269 14.3254 6.40707 14.2128 6.1594 14.0158L6.05784 13.927C5.75681 13.6236 5.61287 13.1706 5.68772 12.6604V12.6594L6.04612 10.1506V10.1486C6.10002 9.7578 6.3736 9.21595 6.65256 8.93672L13.2199 2.36934C14.0025 1.58692 14.7381 1.24824 15.425 1.24824ZM15.2483 1.67695C14.5775 1.73903 14.0149 2.16655 13.5149 2.66231L13.5139 2.66328L6.94748 9.23066C6.82346 9.35469 6.71382 9.53023 6.63498 9.68672C6.55617 9.84322 6.48142 10.0336 6.4553 10.2033L6.45432 10.2082L6.09592 12.716V12.718C6.05201 13.0364 6.10653 13.3868 6.35569 13.6359C6.60486 13.8851 6.95526 13.9396 7.27366 13.8957H7.27561L9.7844 13.5373H9.7883C9.95703 13.5113 10.1487 13.4357 10.3069 13.3566C10.4595 13.2803 10.6359 13.1709 10.76 13.0432L10.761 13.0441L17.3283 6.47774C17.8953 5.91074 18.2597 5.3402 18.3147 4.74629C18.3815 4.02132 17.9945 3.33041 17.3303 2.65742L17.3283 2.65547L17.0637 2.40742C16.4504 1.87014 15.8556 1.6208 15.2483 1.67695Z",
    stroke: "#9C4FFF",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.3734 3.24261C12.4859 3.21413 12.5938 3.27801 12.6234 3.38519L12.6244 3.38812C13.1638 5.30258 14.6806 6.82046 16.5951 7.3598H16.598C16.7019 7.38841 16.7722 7.5036 16.7396 7.6225L16.7386 7.6264C16.7148 7.71647 16.6384 7.77484 16.5414 7.77484C16.5319 7.77482 16.523 7.77392 16.516 7.77289C16.5111 7.77215 16.5082 7.77121 16.5072 7.77093L16.4974 7.768L16.4877 7.76605L16.1078 7.64496C14.2358 6.98229 12.7672 5.42691 12.2259 3.50335C12.1975 3.39419 12.2575 3.27997 12.3734 3.24261Z",
    stroke: "#9C4FFF",
    strokeWidth: 0.833333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0,
    d: "M19.583 0.416992V19.583H0.416992V0.416992H19.583Z",
    stroke: "#9C4FFF",
    strokeWidth: 0.833333
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.d1f697d0d8e84723635a84aca3b9c25a.svg";